export const getParams = <T extends Record<string, unknown>>(
  param: T
): { [K in keyof T]: string } => {
  const result: { [K in keyof T]: string } = {} as { [K in keyof T]: string };

  for (const key in param) {
    if (Object.prototype.hasOwnProperty.call(param, key)) {
      const value = param[key];
      // Only include the parameter if it has a valid value
      if (value !== undefined && value !== null && value !== '') {
        result[key] = String(value);
      }
    }
  }

  return result;
};
